export const formatNull = (data) => {
    return data ?? ''
}